import { jsx } from "react/jsx-runtime";
import { lazy, useLayoutEffect, Fragment } from "react";
import { Provider } from "react-redux";
import { I18nService } from "@perxis-auto/shared/lib";
import { Provider as Provider$1 } from "@perxis-auto/ui-kit/lib/components/Provider";
import enTranslation from "../../shared/assets/locales/en/translation.json.js";
import ruTranslation from "../../shared/assets/locales/ru/translation.json.js";
import uzTranslation from "../../shared/assets/locales/uz/translation.json.js";
import { APP } from "../../shared/config/app.js";
import "../../shared/config/env.js";
import "../../shared/config/events.js";
import "../../shared/context/constructor.js";
import { StoreContext } from "../../shared/context/store.js";
import "../../shared/context/this.js";
import "@perxis-auto/shared";
import "../../shared/lib/constructor/mergeConstructor.js";
import "@perxis-auto/ui-kit";
import { formatShortDay } from "../../shared/lib/format/locale/formatShortDay.js";
import { formatShortTime } from "../../shared/lib/format/locale/formatShortTime.js";
import { LanguageEnum, CurrencyEnum } from "../../shared/types/internationalization.js";
import "../../shared/lib/logger/index.js";
import "react-router";
import "@perxis-auto/shared/lib/lib/is/isObject";
import "../../shared/lib/store/createAppApi.js";
import "../../shared/lib/store/createAppAsyncThunk.js";
import "../../shared/lib/store/createAppSelector.js";
import "../../shared/lib/store/createAppSlice.js";
import "redux";
import "../../shared/lib/store/hooks/useAppDispatch.js";
import { useAppSelector } from "../../shared/lib/store/hooks/useAppSelector.js";
import "../../shared/lib/store/hooks/useAppStore.js";
import "../../shared/store/config/middleware/index.js";
import "../../shared/store/config/model/selectors/selectBenefits.js";
import "../../shared/store/config/model/selectors/selectBooking.js";
import { selectCredit } from "../../shared/store/config/model/selectors/selectCredit.js";
import "../../shared/store/config/model/selectors/selectFilterGrid.js";
import "../../shared/store/config/model/selectors/selectFilterGridItems.js";
import "../../shared/store/config/model/selectors/selectFilters.js";
import "../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../shared/store/config/model/selectors/selectMaps.js";
import "../../shared/store/config/model/selectors/selectModels.js";
import { selectSlice } from "../../shared/store/config/model/selectors/selectSlice.js";
import "../../shared/store/config/model/selectors/selectSort.js";
import "../../shared/store/config/model/selectors/selectTags.js";
import { selectTradeIn } from "../../shared/store/config/model/selectors/selectTradeIn.js";
import "../../shared/store/config/model/slice.js";
const CreditInstockProvider = lazy(
  () => import("@perxis-auto/credit-instock").then((module) => ({ default: module.default.Provider }))
);
const TradeInProvider = lazy(
  () => import("@perxis-auto/trade-in-instock").then((module) => ({ default: module.default.Provider }))
);
const DEFAULT_CREDIT_PARAMS_FORMATTER = (choice) => {
  return {
    currency: CurrencyEnum.RUB,
    ...choice
  };
};
const InternalInstockProvider = ({ children }) => {
  const { language, currency } = useAppSelector(selectSlice);
  const credit = useAppSelector(selectCredit);
  const tradeIn = useAppSelector(selectTradeIn);
  const isCreditEnable = !!(credit == null ? void 0 : credit.enable) && !!credit.apiRoot && !!credit.clientId;
  const isTradeInEnable = !!(tradeIn == null ? void 0 : tradeIn.enable) && !!tradeIn.apiRoot && !!tradeIn.clientId;
  const ResolvedCreditInstockProvider = isCreditEnable ? CreditInstockProvider : Fragment;
  const ResolvedTradeInProvider = isTradeInEnable ? TradeInProvider : Fragment;
  return /* @__PURE__ */ jsx(
    ResolvedTradeInProvider,
    {
      clientId: tradeIn.clientId,
      apiRoot: tradeIn.apiRoot,
      language,
      eventsHandler: tradeIn.eventsHandler,
      children: /* @__PURE__ */ jsx(
        ResolvedCreditInstockProvider,
        {
          clientId: credit.clientId,
          apiRoot: credit.apiRoot,
          currency,
          language,
          displayProgramName: credit.displayProgramName,
          creditParamsFormatter: credit.creditParamsFormatter || DEFAULT_CREDIT_PARAMS_FORMATTER,
          eventsHandler: credit.eventsHandler,
          children
        }
      )
    }
  );
};
function InstockProvider({ children, store }) {
  const { context = StoreContext, ...reduxProps } = store;
  useLayoutEffect(() => {
    var _a, _b;
    I18nService.getInstance().i18n.addResourceBundle(LanguageEnum.En, APP.name, enTranslation, true, true).addResourceBundle(LanguageEnum.Ru, APP.name, ruTranslation, true, true).addResourceBundle(LanguageEnum.Uz, APP.name, uzTranslation, true, true);
    (_a = I18nService.getInstance().i18n.services.formatter) == null ? void 0 : _a.add(...formatShortDay());
    (_b = I18nService.getInstance().i18n.services.formatter) == null ? void 0 : _b.add(...formatShortTime());
  }, []);
  return /* @__PURE__ */ jsx(Provider, { context, ...reduxProps, children: /* @__PURE__ */ jsx(Provider$1, { children: /* @__PURE__ */ jsx(InternalInstockProvider, { children }) }) });
}
export {
  InstockProvider
};
